import { useEffect, useState } from "react";
import type { Strings } from "../i18n/strings";
import type { Prophecy } from "../lib/types";
import { playRise } from "../lib/sound";
import { hapticSoft } from "../lib/native";
import Moon from "./Moon";

interface Props {
  t: Strings;
  oneLine: string; // 보편적 한 마디(요약) — 편지 맨 위에 표시.
  letter: string; // 4악장, 문단은 "\n\n" 구분.
  prophecy: Prophecy; // 편지 끝 블러 코다.
  onBack: () => void; // 헤더 ← (처음으로)
  onNext: () => void; // 카드로(간직)
}

// S3 · 달의 편지 + 예언(한 화면). 편지가 위에서부터 강림 → 맨 끝에 예언 한 줄이 블러 코다로, 두드리면 공개.
export default function Letter({ t, oneLine, letter, prophecy, onBack, onNext }: Props) {
  const paras = letter.split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    playRise();
    hapticSoft();
  }, []);

  const prophBody = (
    <>
      <div className="proph-text">{prophecy.text}</div>
      {prophecy.caption && <div className="proph-cap">{prophecy.caption}</div>}
    </>
  );

  return (
    <div className="screen letter">
      <div className="flow-header-abs">
        <button className="navbtn" onClick={onBack}>
          ← {t.back}
        </button>
        <span />
      </div>
      <div className="letter-moon">
        <Moon size={64} />
      </div>
      <div className="letter-scroll">
        <div className="letter-oneline">{oneLine}</div>
        <div className="letter-body">
          {paras.map((p, i) => (
            <p key={i} style={{ animationDelay: `${0.25 + i * 0.55}s` }}>
              {p}
            </p>
          ))}
        </div>

        {/* 예언 코다 — 편지 꼬리에 블러 한 줄, 탭하면 가운데에서 바깥으로 또렷해진다. */}
        <div className="proph-coda">
          <div className="proph-coda-kicker">✦ {t.prophecyKicker}</div>
          <div className={`proph-coda-card ${open ? "open" : ""}`} onClick={() => !open && setOpen(true)}>
            <div className="proph-card-glow" />
            <div className="proph-reveal">
              <div className="proph-layer proph-layer-blur" aria-hidden={open}>
                {prophBody}
              </div>
              <div className="proph-layer proph-layer-sharp" aria-hidden={!open}>
                {prophBody}
              </div>
            </div>
            {!open && <div className="proph-tap">✦ {t.blurHint}</div>}
          </div>
        </div>
      </div>

      <div className="letter-fade" />
      <button className="letter-next" onClick={onNext}>
        {t.keep} →
      </button>
    </div>
  );
}
